import { render, staticRenderFns } from "./Referal.vue?vue&type=template&id=5ca8d077&"
import script from "./Referal.vue?vue&type=script&lang=js&"
export * from "./Referal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports